import {SET_AVATAR} from "../constants";
import {getUser} from 'services/user';
import {serverUrl} from 'services/network';

const initialState = () => {
    const user = getUser();

    if (user && user.avatar)
        return user.avatar;
    return '';
};
const avatar = (state = initialState(), action) => {
    switch (action.type) {
        case SET_AVATAR:
            return action.payload;
        default:
            return state;
    }
};

export default avatar;
